import fields from './fields.json'
import errors from './errors.json'
import success from './success.json'
import home from './home.json'
import subscribe from './subscribe.json'
import footerNav from './footerNavigation.json'
import footer from './footer.json'
import subscription from './subscription.json'
import prices from './prices.json'
import promo from './promo.json'
import paymentTypes from './paymentTypes.json'
import download from './download.json'
import faq from './faq.json'
import auth from './auth.json'
import blog from './blog.json'
import referral from './referral.json'
import partners from './partners.json'
import account from './account.json'
import header from './header.json'
import navigation from './navigation.json'
import modals from './modals.json'
import payment from './payment.json'
import meta from './meta.json'
import reviews from './reviews.json'
import tutorial from './tutorial.json'
import glossary from './glossary.json'

export default {
  fields,
  errors,
  success,
  home,
  subscribe,
  footerNav,
  footer,
  subscription,
  prices,
  promo,
  paymentTypes,
  download,
  faq,
  auth,
  blog,
  referral,
  partners,
  account,
  header,
  navigation,
  modals,
  payment,
  meta,
  reviews,
  tutorial,
  glossary
};
